import { apiRequest } from './api-request'
import {config} from "@/config";

export const API = {
  getServicesList() {
    return apiRequest({
      URL: config.baseAssetUrl + '/json/services-list.json',
      SHOW_ERROR_DETAILS: true
    })
  },
  getMovingItems() {
    return apiRequest({
      URL: '/json/moving-items.json',
      SHOW_ERROR_DETAILS: true
    })
  },
  getMovingPackages() {
    return apiRequest({
      URL: '/json/moving-packages.json',
      SHOW_ERROR_DETAILS: true
    })
  },
  getStorageItems() {
    return apiRequest({
      URL: '/json/storage-items.json',
      SHOW_ERROR_DETAILS: true
    })
  },
  getPartnerItems() {
    return apiRequest({
      URL: '/json/partner-items.json',
      SHOW_ERROR_DETAILS: true
    })
  },
  getPartnerPackageItems(address) {
    return apiRequest({
      URL: '/json/partner-packages-list.json',
      DATA: address
    })
  },
  getDateTimes(data) {
    return apiRequest({
      URL: '/json/date-times.json',
      METHOD: 'POST',
      DATA: data
    })
  },
  promoCodeCheck(data) {
    return apiRequest({
      URL: '/api/promocodecheck',
      METHOD: 'POST',
      DATA: data
    })
  },
  promoCodeCheckFinalize(data) {
    return apiRequest({
      URL: '/api/promocodecheck-finalization',
      METHOD: 'POST',
      DATA: data
    })
  },
  zipCodeCheck(data) {
    return apiRequest({
      URL: '/api/zip-code/check',
      DATA: data,
      SHOW_ERROR_DETAILS: false
    })
  },
  zipCodeSubscribe(DATA) {
    return apiRequest({
      METHOD: 'POST',
      URL: '/api/zip-code/subscribe',
      DATA
    })
  },

  userAuthCheck() {
    return apiRequest({ URL: '/api/user/me' })
  },

  userAuth(data) {
    return apiRequest({
      URL: '/api/user/auth',
      METHOD: 'POST',
      DATA: data
    })
  },
  userRegister(data) {
    return apiRequest({
      URL: '/api/user/register',
      METHOD: 'POST',
      DATA: data
    })
  },
  finalizeCheckout(data) {
    return apiRequest({
      URL: '/api/finalize-checkout',
      METHOD: 'POST',
      DATA: data,
      SHOW_ERROR_DETAILS: true
    })
  },
  orderCheckout(data) {
    return apiRequest({
      URL: '/api/order/checkout',
      METHOD: 'POST',
      DATA: data,
      SHOW_ERROR_DETAILS: true
    })
  },
  orderCalculate(data) {
    return apiRequest({
      URL: '/api/order/calculate',
      METHOD: 'POST',
      DATA: data,
      SHOW_ERROR_DETAILS: true
    })
  },
  partnersMemberRegistration(DATA) {
    return apiRequest({
      URL: '/api/partners-registration',
      METHOD: 'POST',
      DATA,
      SHOW_ERROR_DETAILS: true
    })
  },
  getPartnerRegistrationDates(DATA) {
    return apiRequest({
      URL: '/json/partner-registration-dates.json',
      DATA
    });
  },
  partnersSignInCheck(DATA) {
    return apiRequest({
      URL: '/api/partner-address-check',
      METHOD: 'POST',
      DATA
    })
  },
  partnerSingInTotal(DATA) {
    return apiRequest({
      URL: '/json/partner-registration-total.json',
      SHOW_ERROR_DETAILS: true,
      DATA
    })
  },
  getBrokerPackages() {
    return apiRequest({
      URL: '/api/broker-packages'
    })
  },
  brokerCalculate(DATA) {
    return apiRequest({
      METHOD: 'POST',
      SHOW_ERROR_DETAILS: true,
      URL: '/api/broker-order/calculate',
      DATA
    })
  },
  brokerCheckout(DATA) {
    return apiRequest({
      METHOD: 'POST',
      SHOW_ERROR_DETAILS: true,
      URL: '/api/broker-order/submit',
      DATA
    })
  },
  brokerFinalize(DATA) {
    return apiRequest({
      METHOD: 'POST',
      SHOW_ERROR_DETAILS: true,
      URL: '/api/broker-order/finalize',
      DATA
    })
  },
  sellerCalculate(DATA) {
    return apiRequest({
      METHOD: 'POST',
      SHOW_ERROR_DETAILS: true,
      URL: '/api/seller-order/calculate',
      DATA
    })
  },
  sellerCheckout(DATA) {
    return apiRequest({
      METHOD: 'POST',
      SHOW_ERROR_DETAILS: true,
      URL: '/api/seller-order/submit',
      DATA
    })
  }
}
